export const CBUS = "CBUS";
export const IO = "IO";
